import React from "react";
import PropTypes from "prop-types";
import { BulletList } from "components/ui/BulletList";

export function Links({ links = [] }) {
  const sortedLinks = links.toSorted((a, b) => a.sequence - b.sequence);

  return (
    <>
      <h3>Resources</h3>
      <BulletList>
        {sortedLinks.map((link, index) => (
          <li key={index}>
            <a href={link.url}>{link.title}</a>
            {link.descr && <p style={{ marginTop: 0 }}>{link.descr}</p>}
          </li>
        ))}
      </BulletList>
    </>
  );
}

Links.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      sequence: PropTypes.number,
      descr: PropTypes.string,
    })
  ),
};
